import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError, exhaustMap, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

export const LOGIN_ENPOINT = '/student/login'
export const SIGNUP_ENPOINT = '/student/register'
export const FORGOTPW_ENPOINT = 'student/request-forgot-password'
export const SET_FORGOTPW_ENPOINT = 'student/set-forgot-password'

@Injectable()
export class UserHttpInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.includes(LOGIN_ENPOINT) || request.url.includes(SIGNUP_ENPOINT) || request.url.includes(FORGOTPW_ENPOINT)
      || request.url.includes(SET_FORGOTPW_ENPOINT)) {
      const modifiedReq = request.clone({
        headers: request.headers.set('recaptcha', this.authService.getValueRecapcha())
      });
      return next.handle(modifiedReq);
    }
    return next.handle(request);
  }
}
